
const checkIfAdmin = ( user  ) => user && Object.values( user.groups ).some( group => 'Admin' === group.name )

export default checkIfAdmin